import React from "react"
import styled from 'styled-components'
import { CustomInput, Button } from 'reactstrap'
import shortid from 'shortid'
import get from 'lodash/get'
import { project_status } from '../../constants'
import SearchIcon from "../../../../static/images/search_icon.svg"
import { FONTS } from '../../../../constants'

export default class Searchbar extends React.Component {
  state={ tempSearch: '' }
  render() {
    return (
      <Wrapper>
        <div style={ { display: 'flex' } }>
          <SearchField
            value={ this.state.tempSearch }
            onChange={ (e) => {
              if (e.target.value === '') get(this.props, 'handleSearch')(e.target.value)
              this.setState({ tempSearch: e.target.value })
            } }
            onKeyDown={ (e) => {
              if (e.keyCode === 13) get(this.props, 'handleSearch')(this.state.tempSearch)
            } }
            placeholder={ 'Search By Project Name, Code, Type' }
          />
          <CustomInputField
            type="select"
            id="project_status"
            name="project_status"
            value={ get(this.props, 'selectedStatus') }
            onChange={ (e) => get(this.props, 'handleProjectStatus')(e) }
          >
            {
              project_status.map((g) => (
                <option key={ shortid() } value={ g.value }>{ g.label }</option>)
              )
            }
          </CustomInputField>
          <ExportButton onClick={ () => get(this.props, 'export')() }>
              Export
          </ExportButton>
        </div>
        <CreateBtn onClick={ () => get(this.props, 'toggleCreate')() }>
        + New Project
        </CreateBtn>
      </Wrapper>

    )
  }
}

const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width : 200px;
  height : 30px;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
`
const SearchField = styled.input`
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  padding-left: 30px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width: 250px;
  height: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
  box-sizing: border-box;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const CreateBtn = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #AD2624;
  width: 120px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: #AD2624;
  border-radius: 4px;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const ExportButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: #428BCA;
  width: 70px;
  height: 30px;
  margin-left: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: #428BCA;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
    }
`




// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-project/index.js